<div class="container-fluid my-3">

  <mat-form-field appearance="outline">
    <mat-label>Sök</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Sök på Description eller Log..." #input>
  </mat-form-field>

  <mat-paginator [length]="total || 0" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
      <td mat-cell *matCellDef="let orderLog"> {{ orderLog.description }} </td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
      <td mat-cell *matCellDef="let orderLog"> {{ orderLog.created | date: 'yyyy-MM-dd HH:mm' }} </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
      <td mat-cell *matCellDef="let orderLog"> {{ orderLog.createdBy }}
        <mat-icon class="clickable" (click)="showDetails(orderLog)">zoom_in</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let orderLog; columns: displayedColumns;" class="clickable">
    </tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">Ingen matchning på "{{input.value}}"...</td>
    </tr>

  </table>

</div>